// extracted by mini-css-extract-plugin
export var fillIn = "FillIn_fillIn__xeRkR";
export var md = "768px";
export var shared = "\"../../../shared.module.css\"";